module.exports = __webpack_public_path__ + "static/media/Medical.6f1cacec.jpg";